import {
  createTicketReservation as publicCreateTicketReservation,
  getTicketReservation as publicGetTicketReservation,
  deleteTicketReservation as publicDeleteTicketReservation,
  bulkUpdateTicketReservationTags as publicBulkUpdateTicketReservationTags,
  bulkUpdateTicketReservationTagsByFilter as publicBulkUpdateTicketReservationTagsByFilter,
  cancelTicketReservation as publicCancelTicketReservation,
} from './events-v1-ticket-reservation-ticket-reservations.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onTicketReservationCreated as publicOnTicketReservationCreated } from './events-v1-ticket-reservation-ticket-reservations.public.js';
import { onTicketReservationDeleted as publicOnTicketReservationDeleted } from './events-v1-ticket-reservation-ticket-reservations.public.js';
import { onTicketReservationUpdated as publicOnTicketReservationUpdated } from './events-v1-ticket-reservation-ticket-reservations.public.js';

export const createTicketReservation: MaybeContext<
  BuildRESTFunction<typeof publicCreateTicketReservation> &
    typeof publicCreateTicketReservation
> = /*#__PURE__*/ createRESTModule(publicCreateTicketReservation);
export const getTicketReservation: MaybeContext<
  BuildRESTFunction<typeof publicGetTicketReservation> &
    typeof publicGetTicketReservation
> = /*#__PURE__*/ createRESTModule(publicGetTicketReservation);
export const deleteTicketReservation: MaybeContext<
  BuildRESTFunction<typeof publicDeleteTicketReservation> &
    typeof publicDeleteTicketReservation
> = /*#__PURE__*/ createRESTModule(publicDeleteTicketReservation);
export const bulkUpdateTicketReservationTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateTicketReservationTags> &
    typeof publicBulkUpdateTicketReservationTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateTicketReservationTags);
export const bulkUpdateTicketReservationTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateTicketReservationTagsByFilter> &
    typeof publicBulkUpdateTicketReservationTagsByFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkUpdateTicketReservationTagsByFilter
);
export const cancelTicketReservation: MaybeContext<
  BuildRESTFunction<typeof publicCancelTicketReservation> &
    typeof publicCancelTicketReservation
> = /*#__PURE__*/ createRESTModule(publicCancelTicketReservation);
/**
 * Triggered when a ticket reservation is created.
 */
export const onTicketReservationCreated: BuildEventDefinition<
  typeof publicOnTicketReservationCreated
> &
  typeof publicOnTicketReservationCreated = createEventModule(
  publicOnTicketReservationCreated
);
/**
 * Triggered when a ticket reservation is deleted.
 */
export const onTicketReservationDeleted: BuildEventDefinition<
  typeof publicOnTicketReservationDeleted
> &
  typeof publicOnTicketReservationDeleted = createEventModule(
  publicOnTicketReservationDeleted
);
/**
 * Triggered when a ticket reservation is updated.
 */
export const onTicketReservationUpdated: BuildEventDefinition<
  typeof publicOnTicketReservationUpdated
> &
  typeof publicOnTicketReservationUpdated = createEventModule(
  publicOnTicketReservationUpdated
);

export {
  ReservationStatus,
  Type,
  CheckoutType,
  FeeType,
  WebhookIdentityType,
  PromotionType,
  OrderStatus,
  SubdivisionType,
} from './events-v1-ticket-reservation-ticket-reservations.universal.js';
export {
  TicketReservation,
  TicketLineItem,
  TicketInfo,
  SeatInfo,
  PricingPlan,
  EventSettingsSnapshot,
  CommonMoney,
  ServiceFee,
  CatalogReference,
  AdditionalReservationSettings,
  ExtendedFields,
  Tags,
  TagList,
  TicketReservationBalanceUpdated,
  TicketReservationBalance,
  TicketDefinitionBalance,
  CreateCheckoutRequest,
  CreateCheckoutResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateTicketReservationRequest,
  CreateTicketReservationResponse,
  PromotionErrors,
  Error,
  GetTicketReservationRequest,
  GetTicketReservationResponse,
  GetCurrentTicketReservationRequest,
  GetCurrentTicketReservationResponse,
  UpdateTicketReservationRequest,
  UpdateTicketReservationResponse,
  UpdateCurrentTicketReservationRequest,
  UpdateCurrentTicketReservationResponse,
  AddTicketsToCurrentTicketReservationRequest,
  AddTicketsToCurrentTicketReservationResponse,
  AddTicketsToTicketReservationRequest,
  AddTicketsToTicketReservationResponse,
  RemoveTicketsFromCurrentTicketReservationRequest,
  RemoveTicketsFromCurrentTicketReservationResponse,
  RemoveTicketsFromTicketReservationRequest,
  RemoveTicketsFromTicketReservationResponse,
  DeleteTicketReservationRequest,
  DeleteTicketReservationResponse,
  DeleteCurrentTicketReservationRequest,
  DeleteCurrentTicketReservationResponse,
  BulkUpdateTicketReservationTagsRequest,
  BulkUpdateTicketReservationTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateTicketReservationTagsResult,
  BulkActionMetadata,
  BulkUpdateTicketReservationTagsByFilterRequest,
  BulkUpdateTicketReservationTagsByFilterResponse,
  ConfirmTicketReservationRequest,
  ConfirmTicketReservationResponse,
  CancelTicketReservationRequest,
  CancelTicketReservationResponse,
  CancelTicketReservationOnGracePeriodEndRequest,
  CancelTicketReservationOnGracePeriodEndResponse,
  ExpireTicketReservationRequest,
  ExpireTicketReservationResponse,
  UpdateTicketReservationCancelableRequest,
  UpdateTicketReservationCancelableResponse,
  Empty,
  OrderArchived,
  Ticket,
  CheckIn,
  Money,
  FormResponse,
  InputValue,
  FormattedAddress,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  StandardDetails,
  OnlineConferencingLogin,
  OrderUnarchived,
  OrderTicketsCanceled,
  QueryEventsWithPaidReservationsRequest,
  EventKey,
  QueryEventsWithPaidReservationsResponse,
  FixArchivedTicketReservationRequest,
  FixArchivedTicketReservationResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  TicketReservationCreatedEnvelope,
  TicketReservationDeletedEnvelope,
  TicketReservationUpdatedEnvelope,
  BulkUpdateTicketReservationTagsOptions,
  BulkUpdateTicketReservationTagsByFilterOptions,
} from './events-v1-ticket-reservation-ticket-reservations.universal.js';
export {
  ReservationStatusWithLiterals,
  TypeWithLiterals,
  CheckoutTypeWithLiterals,
  FeeTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  PromotionTypeWithLiterals,
  OrderStatusWithLiterals,
  SubdivisionTypeWithLiterals,
  CreateTicketReservationApplicationErrors,
  GetTicketReservationApplicationErrors,
  CancelTicketReservationApplicationErrors,
} from './events-v1-ticket-reservation-ticket-reservations.universal.js';
